<template>
  <div class="ai">
    <h1>{{$t('home.AITitle')}}</h1>
    <p>{{$t('home.AIContent')}}</p>
    <div>
      <img src="@/assets/images/W+.png" alt />
      <div>
        <p>{{$t('home.AITitle1')}}</p>
        <p>{{$t('home.AIContent1')}}</p>
      </div>
      <img src="@/assets/images/maisou.png" alt />
      <div>
        <p>{{$t('home.AITitle2')}}</p>
        <p>{{$t('home.AIContent2')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.ai {
  width: 1200px;
  margin: auto;
  padding: 64px 0 80px;
  & h1 {
    margin-bottom: 10px;
  }
  & > p {
    font-size: 20px;
    color: #666666;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 64px;
  }
  & > div {
    display: flex;
    & img {
      width: 220px;
      height: 189px;
      margin-right: 10px;
    }

    & > div {
      width: 340px;
      & > p:first-child {
        font-size: 24px;
        color: #000000;
        letter-spacing: 0;
        margin-bottom: 10px;
      }
      & > p:last-child {
        font-size: 16px;
        color: #666666;
        letter-spacing: 0;
        line-height: 24px;
      }
    }
    & > div:nth-child(2) {
      margin-right: 89px;
    }
  }
}
</style>